/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPackage } from '../fn/packages/create-package';
import { CreatePackage$Params } from '../fn/packages/create-package';
import { getPackageById } from '../fn/packages/get-package-by-id';
import { GetPackageById$Params } from '../fn/packages/get-package-by-id';
import { getPackages } from '../fn/packages/get-packages';
import { GetPackages$Params } from '../fn/packages/get-packages';
import { getPackagesForAdmin } from '../fn/packages/get-packages-for-admin';
import { GetPackagesForAdmin$Params } from '../fn/packages/get-packages-for-admin';
import { PackageCreateResponse } from '../models/package-create-response';
import { PackageDetailedResponse } from '../models/package-detailed-response';
import { PagePackageAdminResponse } from '../models/page-package-admin-response';
import { PagePackagePageResponse } from '../models/page-package-page-response';
import { updatePackage } from '../fn/packages/update-package';
import { UpdatePackage$Params } from '../fn/packages/update-package';
import { updatePackageStatus } from '../fn/packages/update-package-status';
import { UpdatePackageStatus$Params } from '../fn/packages/update-package-status';


/**
 * Package resource endpoints. GET /packages is accessible to all authenticated users. Other operations require PRODUCT_ADMIN or EASYLOT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class PackagesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getPackageById()` */
  static readonly GetPackageByIdPath = '/packages/{packageId}';

  /**
   * Gets package.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackageById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageById$Response(params: GetPackageById$Params, context?: HttpContext): Observable<StrictHttpResponse<PackageDetailedResponse>> {
    const obs = getPackageById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets package.
   *
   * Finds and returns the saved resource with the specified id.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackageById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackageById(params: GetPackageById$Params, context?: HttpContext): Observable<PackageDetailedResponse> {
    const resp = this.getPackageById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PackageDetailedResponse>): PackageDetailedResponse => r.body)
    );
  }

  /** Path part for operation `updatePackage()` */
  static readonly UpdatePackagePath = '/packages/{packageId}';

  /**
   * Updates a package.
   *
   * Updates an existing package based on its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePackage$Response(params: UpdatePackage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updatePackage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a package.
   *
   * Updates an existing package based on its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePackage(params: UpdatePackage$Params, context?: HttpContext): Observable<void> {
    const resp = this.updatePackage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updatePackageStatus()` */
  static readonly UpdatePackageStatusPath = '/admin/packages/status';

  /**
   * Updates the status of package by admin.
   *
   * Updates the status of package based on the provided list of package ids and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePackageStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePackageStatus$Response(params: UpdatePackageStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updatePackageStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of package by admin.
   *
   * Updates the status of package based on the provided list of package ids and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePackageStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePackageStatus(params: UpdatePackageStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updatePackageStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPackages()` */
  static readonly GetPackagesPath = '/packages';

  /**
   * Gets packages.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackages$Response(params: GetPackages$Params, context?: HttpContext): Observable<StrictHttpResponse<PagePackagePageResponse>> {
    const obs = getPackages(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets packages.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackages(params: GetPackages$Params, context?: HttpContext): Observable<PagePackagePageResponse> {
    const resp = this.getPackages$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagePackagePageResponse>): PagePackagePageResponse => r.body)
    );
  }

  /** Path part for operation `createPackage()` */
  static readonly CreatePackagePath = '/packages';

  /**
   * Creates a new package.
   *
   * Creates a new package and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPackage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPackage$Response(params: CreatePackage$Params, context?: HttpContext): Observable<StrictHttpResponse<PackageCreateResponse>> {
    const obs = createPackage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new package.
   *
   * Creates a new package and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPackage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPackage(params: CreatePackage$Params, context?: HttpContext): Observable<PackageCreateResponse> {
    const resp = this.createPackage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PackageCreateResponse>): PackageCreateResponse => r.body)
    );
  }

  /** Path part for operation `getPackagesForAdmin()` */
  static readonly GetPackagesForAdminPath = '/admin/packages';

  /**
   * Gets packages for admin.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPackagesForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagesForAdmin$Response(params?: GetPackagesForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<PagePackageAdminResponse>> {
    const obs = getPackagesForAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets packages for admin.
   *
   * Finds and returns the saved resources with its identifiers.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPackagesForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPackagesForAdmin(params?: GetPackagesForAdmin$Params, context?: HttpContext): Observable<PagePackageAdminResponse> {
    const resp = this.getPackagesForAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagePackageAdminResponse>): PagePackageAdminResponse => r.body)
    );
  }

}
